<template>
  <component
    :is="c_surveyItemComponent"
    :p_surveyItem="p_surveyItem"
    :p_objValues="p_objValues"
  />
</template>
<script>
import SurveyItemCheckbox from './SurveyItemCheckbox.vue';
import SurveyItemTextarea from './SurveyItemTextarea.vue';
import SurveyItemHide from './SurveyItemHide.vue';

export default {
  name: 'SurveyItem',

  components: {
    'survey-item-checkbox': SurveyItemCheckbox,
    'survey-item-textarea': SurveyItemTextarea,
    'survey-item-hide': SurveyItemHide,
  },

  props: {
    p_surveyItem: {
      type: Object,
      default: () => ({}),
    },

    p_objValues: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    c_surveyItemComponent() {
      return `survey-item-${this.p_surveyItem.surveyItemType}`;
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
